"use client";
import React, { useState } from "react";

interface TickerMessage {
  text: string;
  show?: boolean;
}

interface TickerProps {
  messages?: TickerMessage[];
  backgroundColor?: string;
  textColor?: string;
}

export function Ticker({ messages, backgroundColor, textColor }: TickerProps) {
  const [isHovered, setIsHovered] = useState(false);

  // Use CMS messages if provided and visible
  const visibleMessages = messages?.filter(m => m.show !== false) ?? [];
  
  if (visibleMessages.length === 0) return null;

  const repeated = Array.from({ length: 50 }, () => visibleMessages).flat();

  return (
    <div
      className="w-full overflow-hidden py-[6px] sm:py-[6px] md:py-[8px] lg:py-[10px] whitespace-nowrap"
      style={{ backgroundColor: backgroundColor || '#005dd8' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="inline-flex"
        style={{
          animation: "scrollAnimation 300s linear infinite",
          animationPlayState: isHovered ? "paused" : "running",
        }}
      >
        {repeated.map((item, i) => (
          <span
            key={i}
            className="mr-8 sm:mr-12 text-[12px] sm:text-[14px] lg:text-[16px] whitespace-nowrap inline-flex items-center"
            style={{ color: textColor || '#ffffff' }}
          >
            {item.text}
          </span>
        ))}
      </div>

      {/* INLINE KEYFRAMES */}
      <style>
        {`
          @keyframes scrollAnimation {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </div>
  );
}
